import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "home-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "home bsp-page__content"
}
const _hoisted_3 = {
  key: 0,
  class: "client-view"
}
const _hoisted_4 = {
  class: "bsp-onboarding-section",
  "aria-labelledby": "onboarding-title"
}
const _hoisted_5 = { class: "bsp-action-grid" }
const _hoisted_6 = {
  class: "bsp-channel-icon bsp-channel-icon--primary",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  class: "bsp-channel-icon bsp-channel-icon--whatsapp",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  class: "bsp-section whatsapp-accounts-container",
  "aria-labelledby": "accounts-title"
}
const _hoisted_9 = { class: "bsp-section-heading bsp-section-heading--toolbar" }
const _hoisted_10 = { class: "bsp-section-heading__title-row" }
const _hoisted_11 = { class: "bsp-toolbar" }
const _hoisted_12 = {
  key: 0,
  class: "bsp-account-grid"
}
const _hoisted_13 = {
  class: "bsp-channel-icon bsp-channel-icon--whatsapp",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "whatsapp-account-info" }
const _hoisted_15 = {
  key: 1,
  class: "no-client-view bsp-empty-page"
}

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref, computed } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import SignupProgressModal from '../components/SignupProgressModal.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import { WhatsappBusinessAccount } from '../services/AccountService/types'
import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import MetaService from '@/services/MetaService/MetaService'
import { useEmbeddedSignup } from '@/composables/useEmbeddedSignup'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AEmptyViewCard, AIcon, AInput, ATag } from '@adereso-ai/vue-components'
import { normalizeSearchTerm } from '@/utils/search'


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsappBusinessAccountsView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const {
  signupFlowStatus,
  signupErrorMessage,
  signupSteps,
  isSignupActionDisabled,
  showSignupProgressModal,
  signupModalTitle,
  signupModalDescription,
  launchWhatsAppSignup,
  closeSignupModal
} = useEmbeddedSignup({
  async onSuccess () {
    await getAccounts()
  }
})

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
const establishmentName = ref('')
const whatsappBusinessAccounts = ref<Array<WhatsappBusinessAccount>>([])
const accountSearch = ref('')

const accountBreadcrumbs = [
  {
    title: 'WhatsApp Accounts',
    disabled: true,
    icon: 'tabler:brand-whatsapp'
  }
]

const filteredAccounts = computed(() => {
  const search = normalizeSearchTerm(accountSearch.value)
  if (!search) return whatsappBusinessAccounts.value
  return whatsappBusinessAccounts.value.filter((account) => {
    return account.name.toLocaleLowerCase().includes(search) || account.id.includes(search)
  })
})

const isSuperUser = computed(() => {
  return currentUser.value?.roles.includes('superuser')
})

async function goToWhatsappBusinessAccount (wabaId: string) {
  router.push({ name: 'whatsapp-business-account', params: { wabaId } })
}

async function goToMediaTools () {
  router.push({ name: 'media-tools' })
}

async function goToConfigClient () {
  router.push({ name: 'config-client' })
}

async function getAccounts () {
  const accountService = await AccountService.getInstance()
  try {
    whatsappBusinessAccounts.value = await accountService.getWhatsappBusinessAccounts()
  } catch (error) {
    // do nothing
  }
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  if (currentEstablishment.value) {
    await getAccounts()
  }

  loading.value = false
})

async function createEstablishment () {
  if (establishmentName.value === '') {
    toastError('Establishment name is required')
    return
  }
  const establishmentService = await EstablishmentService.getInstance()
  await establishmentService.createEstablishment(establishmentName.value)
  router.push('/')
}

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

async function SynchronizeWhatsappBusinessAccounts () {
  loading.value = true
  const metaService = await MetaService.getInstance()
  await metaService.synchronizeWhatsappBusinessAccounts()
  await getAccounts()
  loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (currentUser.value && currentEstablishment.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(BspPageHeader, {
                  class: "bsp-page-header--welcome",
                  breadcrumbs: accountBreadcrumbs,
                  title: `Hello, ${currentUser.value.name}`,
                  description: `Manage the accounts and phone numbers for ${currentEstablishment.value.name}.`,
                  eyebrow: "WhatsApp operations",
                  icon: "tabler:brand-whatsapp"
                }, {
                  actions: _withCtx(() => [
                    (isSuperUser.value)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 0,
                          variant: "text",
                          size: "small",
                          "prepend-icon": "tabler:photo",
                          onClick: goToMediaTools
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode(" Media ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (isSuperUser.value)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 1,
                          variant: "text",
                          size: "small",
                          "prepend-icon": "tabler:settings",
                          onClick: goToConfigClient
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" Settings ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  meta: _withCtx(() => [
                    _createVNode(_unref(ATag), {
                      text: currentEstablishment.value.name,
                      color: "brand",
                      type: "secondary",
                      "prepend-icon": "tabler:building"
                    }, null, 8, ["text"])
                  ]),
                  _: 1
                }, 8, ["title", "description"]),
                _createElementVNode("section", _hoisted_4, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bsp-section-heading" }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Set up a channel"),
                      _createElementVNode("h2", { id: "onboarding-title" }, "Add a phone number or WABA"),
                      _createElementVNode("p", null, "Choose the flow that matches the current status of your phone number.")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_card, {
                      class: "bsp-action-card",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:device-mobile-plus",
                            color: "primary",
                            size: "22"
                          })
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bsp-action-card__copy" }, [
                          _createElementVNode("h3", null, "New phone number or migration"),
                          _createElementVNode("p", null, "Create or select a WABA, register a new phone number, or migrate one from another BSP.")
                        ], -1)),
                        _createVNode(_unref(AButton), {
                          color: "blue",
                          "prepend-icon": "tabler:plus",
                          disabled: _unref(isSignupActionDisabled),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(launchWhatsAppSignup)('cloud_api')))
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Register phone number ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card, {
                      class: "bsp-action-card",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:brand-whatsapp",
                            color: "success",
                            size: "22"
                          })
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bsp-action-card__copy" }, [
                          _createElementVNode("h3", null, "WhatsApp Business App"),
                          _createElementVNode("p", null, "Connect a phone number active in the app and enable Coexistence with Cloud API.")
                        ], -1)),
                        _createVNode(_unref(AButton), {
                          variant: "outlined",
                          color: "blue",
                          "prepend-icon": "tabler:link",
                          disabled: _unref(isSignupActionDisabled),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(launchWhatsAppSignup)('coexistence')))
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Connect app ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("section", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[11] || (_cache[11] = _createElementVNode("h2", { id: "accounts-title" }, "WhatsApp Business Accounts", -1)),
                        _createVNode(_unref(ATag), {
                          text: `${filteredAccounts.value.length} of ${whatsappBusinessAccounts.value.length}`,
                          color: "info",
                          type: "secondary"
                        }, null, 8, ["text"])
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("p", null, "Search for an account to manage its phone numbers, templates, and settings.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(AInput), {
                        modelValue: accountSearch.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accountSearch).value = $event)),
                        class: "bsp-search-input",
                        placeholder: "Search by name or ID",
                        "prepend-inner-icon": "tabler:search",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(AButton), {
                        variant: "outlined",
                        color: "blue",
                        "prepend-icon": "tabler:refresh",
                        onClick: SynchronizeWhatsappBusinessAccounts
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode(" Synchronize ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  (filteredAccounts.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAccounts.value, (whatsappAccount) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            class: "bsp-account-card",
                            variant: "flat",
                            key: whatsappAccount.id,
                            tabindex: "0",
                            onClick: ($event: any) => (goToWhatsappBusinessAccount(whatsappAccount.id)),
                            onKeydown: _withKeys(($event: any) => (goToWhatsappBusinessAccount(whatsappAccount.id)), ["enter"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, [
                                _createVNode(_unref(AIcon), {
                                  icon: "tabler:brand-whatsapp",
                                  color: "success",
                                  size: "20"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("h3", null, _toDisplayString(whatsappAccount.name), 1),
                                _createElementVNode("span", null, "ID " + _toDisplayString(whatsappAccount.id), 1)
                              ]),
                              _createVNode(_unref(AButton), {
                                icon: "tabler:chevron-right",
                                variant: "text",
                                size: "small",
                                "help-text": "Open account",
                                onClick: _withModifiers(($event: any) => (goToWhatsappBusinessAccount(whatsappAccount.id)), ["stop"])
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["onClick", "onKeydown"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                        key: 1,
                        icon: "tabler:brand-whatsapp",
                        title: accountSearch.value ? 'No accounts found' : 'No synchronized accounts yet',
                        description: accountSearch.value ? 'Try another name or ID.' : 'Synchronize with Meta to load your WhatsApp Business accounts.',
                        "action-button-label": accountSearch.value ? undefined : 'Synchronize accounts',
                        onAction: SynchronizeWhatsappBusinessAccounts
                      }, null, 8, ["title", "description", "action-button-label"]))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(BspPageHeader, {
                  breadcrumbs: accountBreadcrumbs,
                  title: "Set up your establishment",
                  description: "Create an organization to start managing WhatsApp Business.",
                  eyebrow: "First step",
                  icon: "tabler:building-plus"
                }),
                _createVNode(_component_v_card, {
                  class: "bsp-form-card",
                  variant: "flat"
                }, {
                  default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("h2", null, "New establishment", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("p", null, "We'll use this name to identify your operation within the platform.", -1)),
                    _createVNode(_unref(AInput), {
                      modelValue: establishmentName.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((establishmentName).value = $event)),
                      label: "Establishment name",
                      placeholder: "E.g. Adereso Chile"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(AButton), {
                      color: "blue",
                      block: "",
                      "prepend-icon": "tabler:plus",
                      onClick: createEstablishment
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" Create establishment ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 })),
    _createVNode(SignupProgressModal, {
      visible: _unref(showSignupProgressModal),
      title: _unref(signupModalTitle),
      description: _unref(signupModalDescription),
      steps: _unref(signupSteps),
      "error-message": _unref(signupErrorMessage),
      "flow-status": _unref(signupFlowStatus),
      onClose: _unref(closeSignupModal)
    }, null, 8, ["visible", "title", "description", "steps", "error-message", "flow-status", "onClose"])
  ]))
}
}

})